const setStoreReducer = (state, action) => {
  let payload = { ...action.payload };

  return Object.assign({}, state, { ...payload });
};

export default setStoreReducer;
